import { useInitLogger } from "../useInitLogger/useInitLogger";
import { useInitTracker } from "../useInitTracker/useInitTracker";

export function useInits() {
  useInitTracker();
  useInitLogger();
}
